import { Link } from 'react-router-dom';

export default function EmpoweringWomen() {
  return (
    <div className="min-h-screen bg-slate-50 text-slate-900">
      <section className="overflow-hidden bg-emerald-900 py-24">
        <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
          <div className="rounded-3xl bg-white/95 p-10 shadow-2xl backdrop-blur-xl sm:p-14">
            <p className="mb-4 inline-flex rounded-full bg-emerald-100 px-4 py-1 text-sm font-semibold text-emerald-800">
              Building resilient grazing lands
            </p>
            <h1 className="text-4xl font-semibold tracking-tight text-slate-900 sm:text-5xl lg:text-6xl">
              Empowering Women to Restore Grazing Lands in Kisapuk
            </h1>
            <p className="mt-6 max-w-2xl text-lg leading-8 text-slate-700 sm:text-xl">
              Discover how Maasai women in Kisapuk are reclaiming degraded land, preserving culture, and creating a sustainable future for their families and community.
            </p>
            <div className="mt-10 flex flex-col gap-4 sm:flex-row">
              <Link
                to="/contact"
                className="inline-flex items-center justify-center rounded-full bg-emerald-700 px-8 py-3 text-base font-semibold text-white shadow-lg shadow-emerald-700/20 transition hover:bg-emerald-800"
              >
                Join the Initiative
              </Link>
              <Link
                to="/about"
                className="inline-flex items-center justify-center rounded-full border border-slate-300 bg-white px-8 py-3 text-base font-semibold text-slate-900 transition hover:border-slate-400 hover:bg-slate-50"
              >
                Learn more about Kisapuk
              </Link>
            </div>
          </div>
        </div>
      </section>

      <section className="border-t border-slate-200 bg-white py-20">
        <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
          <div className="grid gap-12 lg:grid-cols-3">
            <div className="rounded-3xl bg-slate-50 p-10 shadow-sm">
              <h2 className="text-2xl font-semibold text-slate-900">About the Initiative</h2>
              <p className="mt-4 text-slate-600 leading-7">
                Soils for the future Africa supports Maasai women in Kisapuk through ecological restoration, pasture management training, and community-led conservation.
              </p>
              <p className="mt-4 text-slate-600 leading-7">
                The initiative empowers women to plant native grasses, enhance soil health, and build grazing systems that withstand drought and support livestock.
              </p>
            </div>

            <div className="rounded-3xl bg-slate-50 p-10 shadow-sm">
              <h2 className="text-2xl font-semibold text-slate-900">Our Approach</h2>
              <ul className="mt-4 space-y-3 text-slate-600 leading-7">
                <li>• Training in regenerative land management</li>
                <li>• Community-led tree and grass planting</li>
                <li>• Protection of natural water sources</li>
                <li>• Support for income opportunities and education</li>
              </ul>
            </div>

            <div className="rounded-3xl bg-slate-50 p-10 shadow-sm">
              <h2 className="text-2xl font-semibold text-slate-900">Impact for Kisapuk</h2>
              <p className="mt-4 text-slate-600 leading-7">
                Women are transforming degraded grazing lands into healthier pastures, reducing livestock losses, and preserving Maasai heritage while fighting harmful practices.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-emerald-900 py-20 text-white">
        <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
          <div className="grid gap-10 lg:grid-cols-2 lg:items-center">
            <div>
              <p className="text-sm uppercase tracking-[0.25em] text-emerald-200">Take action today</p>
              <h2 className="mt-4 text-3xl font-semibold tracking-tight text-white sm:text-4xl">
                Help Maasai women restore grazing lands and secure a sustainable future.
              </h2>
              <p className="mt-6 max-w-xl text-lg leading-8 text-emerald-100">
                Your support helps deliver training, seed distribution, and community outreach that grows stronger soils and stronger families in Kisapuk.
              </p>
            </div>
            <div className="space-y-4 rounded-3xl border border-white/10 bg-white/5 p-8 shadow-2xl shadow-black/10">
              <div>
                <p className="text-sm uppercase tracking-[0.20em] text-emerald-200">Get involved</p>
                <p className="mt-2 text-xl font-semibold text-white">Join the restoration movement with practical support.</p>
              </div>
              <div className="grid gap-3 sm:grid-cols-2">
                <Link
                  to="/contact"
                  className="inline-flex items-center justify-center rounded-full bg-white px-4 py-3 text-sm font-semibold text-emerald-900 transition hover:bg-emerald-100"
                >
                  Contact the team
                </Link>
                <Link
                  to="/programs"
                  className="inline-flex items-center justify-center rounded-full border border-white/20 px-4 py-3 text-sm font-semibold text-white transition hover:border-white hover:bg-white/10"
                >
                  Explore programs
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
